import { CourtInfo } from '../store/types';

export const convertCourtsToTable = (courts: CourtInfo[]) => courts.map((court) => ({
  ...court,
  key: court.id,
}));
